import { CircularProgress } from '@mui/material';
import { LoadingLabel, LoadingRoot } from './styled';
import type { LoadingStateProps } from './types';

const DEFAULT_LABEL = 'Loading drug test reports…';

const LoadingState = ({ label = DEFAULT_LABEL }: LoadingStateProps) => (
  <LoadingRoot role="status" aria-live="polite" aria-busy="true">
    <CircularProgress size={28} />
    <LoadingLabel>{label}</LoadingLabel>
  </LoadingRoot>
);

export default LoadingState;
